module.exports = __webpack_public_path__ + "static/natural-farm-fresh-myanmar-689d63efa8b7cf5ba74c5caffe1d0b02.png";